import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { ConstantMan } from '../constantMan';
import { Action } from '../../models/action';

export interface IBingAdGroupIdModel {
  campaignId: string;
  isFromCampaign: boolean;
  adGroupId: string;
}

export interface IBingKeywordIdModel {
  keywordId: string;
  adGroupId: string;
  campaignId: string;
  isFromCampaign: boolean;
  isFromAdGroup: boolean;
}

export interface IBingCampaignModel {
  biddingScheme: string;
  campaignId: string;
  campaignName: string;
  campaignType: string;
  status: string;
  subType?: string;
  timezone: string; //Note this is not in the standard format (will need to convert to use with moment)
}

export interface IBingAdGroupModel {
  audienceAdsBidAdjustment?: string;
  biddingScheme: string;
  campaignId: string;
  cpcBid: number;
  endDate?: string;
  finalUrlSuffix?: string;
  id: string;
  language?: string;
  name: string;
  network: string;
  startDate: string;
  status: string;
  trackingUrlTemplate?: string;
}

export interface IBingKeywordModel {
  bid: number;
  biddingScheme?: string;
  destinationUrl?: string;
  editorialStatus?: string;
  finalMobileUrls?: Array<string>;
  finalUrls?: Array<string>;
  finalUrlSuffix?: string;
  id: string;
  adGroupId?: string;
  matchType?: string;
  param1?: string;
  param2?: string;
  param3?: string;
  status?: string;
  text?: string;
  trackingUrlTemplate?: string;
}

export class BingActionDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.BINGACTION, apiHelper);
  }

  public loadCampaigns(integrationId: string): Observable<Array<IBingCampaignModel>> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/campaigns?integrationId=' + integrationId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  loadTargets(integrationId: string, campaignId: string): Observable<any> {
    let url =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/campaigns/targeting?integrationId=' +
      integrationId +
      '&campaignId=' +
      campaignId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }
}
